import React from 'react'
import styled from 'styled-components'
import { Event } from '../../../model/Event'
import { getTranslations, ITranslations } from '../../../services/translations'
import { useConfigContext } from '../../App/App'
import Card from './Card/Card'
import DoorBase from './Content/Room/Door/Door'
import DateTime from './Information/DateTime/DateTime'

const Wrapper = styled(Card)`
  flex-direction: column;
  align-items: flex-start;
  padding: 0 8rem 0 8rem;

  @media screen and (orientation: portrait) {
    padding: 0 2.5rem 0 4.5rem;
  }
`

const Door = styled(DoorBase)`
  align-items: center;
  font-size: 10rem;
  margin: 4.5rem 0 4.5rem 0;

  img {
    height: 9rem;
  }
`

interface IHeaderProps {
  isOngoing: boolean
}

const Header = styled.div<IHeaderProps>`
  display: flex;
  line-height: 1;
  align-items: center;
  color: #52a840;
  justify-content: space-between;
  ${(props) => props.isOngoing ? 'color: #c4093a;' : ''}

  .time {
    flex: 1;
    margin: 1rem 3rem 0 .2rem;
    align-self: center;

    .main {
      font-size: 7.5rem;
      font-weight: bold;
    }

    .sub {
      font-size: 3.5rem;
      font-weight: bold;
      padding-left: 1rem;
    }
  }

  @media screen and (orientation: portrait) {
    flex-wrap: wrap;
    align-items: center;

    .time {
      width: 100%;
      /* margin-bottom: 3.5rem; */
    }
  }
`

const EventText = styled.div`
  flex: 5;
  font-size: 7rem;
  font-weight: bold;
  margin: 0 2rem;

  @media screen and (orientation: portrait) {
    font-size: 6.5rem;
    margin: 0;
  }
`

const Logo = styled.img`
  max-width: 15rem;
  margin: 1rem;
`

const Title = styled.div`
  font-size: 7rem;
  font-weight: bold;
  margin: 4rem 0 2rem;
  max-height: 9rem;
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  @media screen and (orientation: portrait) {
    max-height: 32rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`

const Description = styled.div`
  font-size: 5rem;
  max-height: 23rem;
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;


  @media screen and (orientation: portrait) {
    max-height: 85rem;
    display: -webkit-box;
    -webkit-line-clamp: 11;
    -webkit-box-orient: vertical;
  }
`

interface IProps {
  event: Event
}

const OneEvent = ({ event }: IProps) => {
  const { busyRoomTitle, eventTitle, langCode, nextRoomTitle, showDescription, showEventLogo } = useConfigContext()
  const translations: ITranslations = getTranslations(langCode)
  const { room, fromDate, toDate, logoFilePath, summary, description } = event
  const showLogo = logoFilePath && showEventLogo
  const occupiedText = busyRoomTitle ? busyRoomTitle : translations.roomOccupied
  const nextText = nextRoomTitle ? nextRoomTitle : translations.roomNext
  const showNextText = !event.isOngoing() || event.isEarlyStart()
  const title = summary && summary !== '' ? summary : (eventTitle ? eventTitle : '------')
  const hasDescription = showDescription && description

  return (
    <Wrapper event={event}>
      {room.door && <Door doorNumber={room.door}/>}
      <Header isOngoing={event.isOngoing()}>
        <DateTime fromDate={fromDate} toDate={toDate}/>
        {event.isOngoing() && <EventText>
          {occupiedText}
        </EventText>}
        {showNextText && <EventText>
          {nextText}
        </EventText>}
        {showLogo && <Logo src={logoFilePath} alt="event logo"/>}
      </Header>
      <Title>
        {title}
      </Title>
      {hasDescription && <Description dangerouslySetInnerHTML={{ __html: description }}/>}
    </Wrapper>
  )
}

export default OneEvent
